/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
* Used to update attachment records in the database...
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { Attachment } from '@src/app/model/attachment';
@Injectable({
  providedIn: 'root'
})
export class AttachmentService extends AbstractHttpService {
  protected http = inject(HttpClient);
  protected messageService = inject(MessageService);


  protected typeString = 'Attachments';
    protected get baseUrl() {
        return this.getAjaxPath('attachments');
    }
  protected cache: Attachment[] = [];
}
